import API, { handleRequest } from "@/api/lib/api";

export const getStaffLeaves = (restaurant_id, date) =>
  handleRequest(() =>
    API.get(`restaurant/staff-leaves/${restaurant_id}?date=${date}`)
  );

export const getStaffLeavesById = (staff_id) =>
  handleRequest(() =>
    API.get(`staff-leave/${staff_id}`)
  );

export const approveStaffLeave = (leave_id) =>
  handleRequest(() => API.get(`restaurant/staff-leaves/approve/${leave_id}`));

export const rejectStaffLeave = (leave_id) =>
  handleRequest(() => API.get(`restaurant/staff-leaves/reject/${leave_id}`));

export const updateStaffLeave = (leave_id, data) =>
  handleRequest(() =>
    API.put(`restaurant/staff-leaves/update/${leave_id}`, data)
  );

export const createStaffLeave = (data) =>
  handleRequest(() => API.post("restaurant/staff-leaves", data));

export const applyStaffLeave = (data) =>
  handleRequest(() => API.post("staff-leave", data));
